<template>
  <body>
    <div
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin5"
      data-sidebartype="full"
      data-sidebar-position="absolute"
      data-header-position="absolute"
      data-boxed-layout="full"
    >
      <Header></Header>

      <Sidebar></Sidebar>

      <div class="dashboard-wrapper page-wrapper">
        <div class="page-breadcrumb">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
              <h4 class="page-title">Edit Company</h4>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 col-xlg-9 col-md-12">
              <form
                class="form-horizontal form-material"
                v-on:submit.prevent="submit"
              >
                <div class="card profile-card">
                  <div class="card-body">
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Subscription</label>
                      <div class="col-md-12 border-bottom p-0">
                        <select
                          multiple="true"
                          name="subscription"
                          v-model="item.subscription"
                          class="form-control"
                        >
                          <option value="">Select Subscription</option>
                          <option
                            v-for="subscription in subscriptions"
                            v-bind:key="subscription.name"
                            v-bind:value="subscription.id"
                          >
                            {{ subscription.name }}
                          </option>
                        </select>
                        <!-- <span>Selected: {{ item.subscription }}</span>--->
                      </div>
                    </div>
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Category</label>
                      <div class="col-md-12 border-bottom p-0">
                        <select
                          multiple="true"
                          name="category"
                          v-model="item.category"
                          class="form-control"
                        >
                          <option value="">Select Category</option>
                          <option
                            v-for="category in categories"
                            v-bind:key="category.name"
                            v-bind:value="category.id"
                          >
                            {{ category.name }}
                          </option>
                        </select>
                        <!-- <span>Selected: {{ item.subscription }}</span>--->
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Name</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="name"
                          v-model="item.name"
                        />
                      </div>
                    </div>
                      <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Email</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="name"
                          v-model="item.email"
                        />
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">About</label>
                      <div class="col-md-12 border-bottom p-0">
                        <textarea
                          name="about"
                          v-model="item.about"
                          class="form-control form-control-lg"
                          rows="5"
                        ></textarea>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Offer Redeem Code</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="code"
                          v-model="item.code"
                        />
                      </div>
                    </div>
                <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Company Logo</label>
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImage"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValue.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValue"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageData!=null">
                          <img class="preview" :src="picture" />

                          <a @click="onUpload" class="upload-btn">Upload</a>
                        </div>
                        <div v-else>
                          <img class="imagefromdata" :src="item.image" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- hero image -->
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Company background  Image</label>
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImagech"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValuech.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValuech"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageDatach!=null">
                          <img class="preview" :src="picturech" />

                          <a @click="onUploadch" class="upload-btn">Upload</a>
                        </div>
                        <div v-else>
                          <img class="imagefromdata" :src="item.background_image" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End of the hero image -->
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Location</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="location"
                          v-model="item.location"
                        />
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Country</label>
                      <div class="col-md-12 border-bottom p-0">
                        <!--<input type="text" class="form-control" name="country" v-model="item.country"/>-->
                        <select
                          name="country"
                          v-model="item.country"
                          class="form-control"
                        >
                          <option value="">Select Country</option>
                          <option
                            v-for="country in countries"
                            v-bind:key="country.name"
                            v-bind:value="country.id"
                          >
                            {{ country.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Postcode</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="postcode"
                          v-model="item.postcode"
                        />
                      </div>
                    </div>
                

                    <div class="main">
                      <div class="flex">
                        <!-- Map Display here -->
                        <div class="map-holder">
                          <div id="map"></div>
                        </div>

                        <!-- Coordinates Display here -->
                        <div class="dislpay-arena">
                          <div class="coordinates-header">
                            <h3>Current Coordinates</h3>
                            <p>Latitude: {{ center[0] }}</p>
                            <p>Longitude: {{ center[1] }}</p>
                          </div>

                          <div class="coordinates-header">
                            <h3>Current Location</h3>
                            <div class="form-group">
                              <input
                                type="text"
                                class="location-control"
                                :value="location"
                                readonly
                              />
                              <button
                                type="button"
                                class="copy-btn"
                                @click="copyLocation"
                              >
                                Copy
                              </button>
                            </div>
                            <button
                              type="button"
                              :disabled="loading"
                              :class="{ disabled: loading}"
                              class="location-btn"
                              @click="getLocation"
                            >
                              Get Location
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Phone No</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="phone_no"
                          v-model="item.phone_no"
                        />
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Website</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="website"
                          v-model="item.website"
                        />
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Outlets included</label>
                      <div class="col-md-12 p-0 collapse-col">
                        <div v-for="(find, index) in finds" :key="find.value">
                          <input
                            v-model="find.address"
                            class="form-control form-control-lg"
                            placeholder="Enter Address"
                          />
                          <input
                            v-model="find.city"
                            class="form-control form-control-lg"
                            placeholder="Enter City"
                          />
                          <span
                            class="
                              delete
                              btn
                              button-white
                              uppercase
                              fas
                              fa-times
                            "
                            @click="deleteFind(index)"
                          >
                          </span>
                        </div>

                        <span
                          id="add"
                          @click="addFind"
                          class="
                            btn
                            add-more
                            button-yellow
                            uppercase
                            fas
                            fa-plus
                          "
                        ></span>

                        <!--  <pre>{{ $data }}</pre> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card profile-card">
                  <div class="card-body">
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Meta Title</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name=""
                          v-model="item.meta_title"
                        />
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Meta Description</label>
                      <div class="col-md-12 border-bottom p-0">
                        <textarea
                          name="meta_description"
                          v-model="item.meta_description"
                          class="form-control form-control-lg"
                          rows="5"
                        ></textarea>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Meta Keywords</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="meta_keywords"
                          v-model="item.meta_keywords"
                        />
                      </div>
                    </div>

                    <br />
                    <div class="form-group mb-4">
                      <div class="col-sm-12">
                        <input
                          type="submit"
                          class="btn btn-primary"
                          value="Submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>
  </body>
</template>
<style scoped>
.main {
  padding: 45px 50px;
}
.flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.map-holder {
  width: 65%;
}
#map {
  height: 70vh;
}
.dislpay-arena {
  background: #ffffff;
  box-shadow: 0px -3px 10px rgba(0, 58, 78, 0.1);
  border-radius: 5px;
  padding: 20px 30px;
  width: 25%;
}
.coordinates-header {
  margin-bottom: 50px;
}
.coordinates-header h3 {
  color: #1f2a53;
  font-weight: 600;
}
.coordinates-header p {
  color: rgba(13, 16, 27, 0.75);
  font-weight: 600;
  font-size: 0.875rem;
}
.form-group {
  position: relative;
}
.location-control {
  height: 30px;
  background: #ffffff;
  border: 1px solid rgba(31, 42, 83, 0.25);
  box-shadow: 0px 0px 10px rgba(73, 165, 198, 0.1);
  border-radius: 4px;
  padding: 0px 10px;
  width: 90%;
}
.location-control:focus {
  outline: none;
}
.location-btn {
  margin-top: 15px;
  padding: 10px 15px;
  background: #d80739;
  box-shadow: 0px 4px 10px rgba(73, 165, 198, 0.1);
  border-radius: 5px;
  border: 0;
  cursor: pointer;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 600;
}
.location-btn:focus {
  outline: none;
}
.disabled {
  background: #db7990;
  cursor: not-allowed;
}
.copy-btn {
  background: #f4f6f8 0% 0% no-repeat padding-box;
  border: 1px solid #f4f6f8;
  border-radius: 0px 3px 3px 0px;
  position: absolute;
  color: #5171ef;
  font-size: 0.875rem;
  font-weight: 500;
  height: 30px;
  padding: 0px 10px;
  cursor: pointer;
  right: 3.5%;
  top: 5%;
}
.copy-btn:focus {
  outline: none;
}
</style>
<script>
import mapboxgl from "mapbox-gl";
import axios from "axios";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import Header from './../admin-header';
import Footer from './../admin-footer';
import Sidebar from './../admin-sidebar';
import firebase from 'firebase';
import { db } from '../../main'

export default{
     name: 'Edit',
        data(){
            return{	 loading: false,
      locations: "",
      access_token: "pk.eyJ1IjoiaW50cm9zYnMiLCJhIjoiY2t2MHU4bWE4M2h1OTMwczcxMm03YmM0eSJ9.ocDaQEjuvL3rUd50oaB6Qw",
      center: [0,0],
      map: {},
                item:{},
          
              imageData: null,
			picture: null,
			uploadValue: 0,
			imageDatach: null,
			picturech: null,
      image:null,
      background_image:null,
			uploadValuech: 0,
                asas:'',
                latmap:'',
                lanmap:'',
                options: [],
                categories: [],
                subscriptions: [],
                finds: [],
                countries: [],
            }
        },
  mounted() {
    this.createMap();
  },
        components:{
            'Header':Header,
            'Sidebar':Sidebar,
            'Footer':Footer,

        },

        created: function(){
            this.getItem();
            this.getSubscription();
            this.getCategory();
            this.getCountries();
        },

        methods: {  		previewImage(event) {
				this.uploadValue = 0;
				this.picture = null;
				this.imageData = event.target.files[0];
				console.log(this.imageData);
			},
			onUpload() {
				this.picture = null;
      // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageData.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
          }
          return result;
        }
				const storageRef = firebase.storage().ref(imagename+makeid(5)+imageextension).put(this.imageData);
				storageRef.on('state_changed', snapshot => {
					this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValue = 100;
					storageRef.snapshot.ref.getDownloadURL().then((url) => {
						this.picture = url;
            //alert(this.picture);
					});
				});
			},
			previewImagech(eventch) {
				this.uploadValuech = 0;
				this.picturech = null;
				this.imageDatach = eventch.target.files[0];
			},
			onUploadch() {
				this.picturech = null;
        // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageDatach.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         // eslint-disable-next-line no-unused-vars
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
          }
          return result;
        }
				const storageRefch = firebase.storage().ref(imagename+makeid(5)+"."+imageextension).put(this.imageDatach);
				storageRefch.on('state_changed', snapshot => {
					this.uploadValuech = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValuech = 100;
					storageRefch.snapshot.ref.getDownloadURL().then((url) => {
						this.picturech = url;
					});
				});
			},

   async createMap() {
      try {
        mapboxgl.accessToken = this.access_token;
        this.map = new mapboxgl.Map({
          container: "map",
          style: "mapbox://styles/mapbox/streets-v11",
          center: this.center,
          zoom: 11,
        });
        let geocoder =  new MapboxGeocoder({
            accessToken: this.access_token,
            mapboxgl: mapboxgl,
            marker: false,
          });
        this.map.addControl(geocoder);
        geocoder.on("result", (e) => {
          const marker = new mapboxgl.Marker({
            draggable: true,
            color: "#D80739",
          })
            .setLngLat(e.result.center)
            .addTo(this.map);
          this.center = e.result.center;
          marker.on("dragend", (e) => {
            this.center = Object.values(e.target.getLngLat());
          });
        });
      } catch (err) {
        console.log("map error", err);
      }
    },
    async getLocation() {
      try {
        this.loading = true;
        const response = await axios.get(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.center[0]},${this.center[1]}.json?access_token=${this.access_token}`
        );
        this.loading = false;
        this.locations = response.data.features[0].place_name;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    copyLocation() {
      if (this.locations) {
        navigator.clipboard.writeText(this.locations);
        alert("Location Copied")
      }
      return;
    },
            addFind: function () {
                this.finds.push({ address: '',city: '' });
            },
            deleteFind: function (index) {
                console.log(index);
                console.log(this.finds);
                this.finds.splice(index, 1);
            },
            getCountries()
            {
            this.countries = [];

                db.collection("countries")
                .get()
                .then((querySnapshot) => {
                    //console.log('hhhh1');
                    querySnapshot.forEach((doc) => {
                    this.countries.push({
                        id: doc.id,
                        name: doc.data().country,
                        slug: doc.data().slug,
                    });
                    //console.log(doc.id, " => ", doc.data());

                    });


                })
                .catch((error) => {
                    console.log("Error getting documents: ", error);
                });
            },


            getSubscription()
            {
                this.subscriptions = [];

                db.collection("subscriptions")
                .get()
                .then((querySnapshot) => {
                    //console.log('hhhh');
                    querySnapshot.forEach((doc) => {
                    this.subscriptions.push({
                        id: doc.id,
                        name: doc.data().title,
                    });
                    //console.log(doc.id, " => ", doc.data());

                    });

                    //console.log(this.subscriptions);
                })
                .catch((error) => {
                    console.log("Error getting documents: ", error);
                });
            },
			getCategory(){
   this.categories = [];

            db.collection("categories")
            .get()
            .then((querySnapshot) => {
                //console.log('hhhh1');
                querySnapshot.forEach((doc) => {
                this.categories.push({
                    id: doc.id,
                     name: doc.data().name,

                });
                //console.log(doc.id, " => ", doc.data());

                });


            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });

		},
            uploadImage(e){
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                    this.previewImage = e.target.result;
                    console.log('dd');
                };
            },

            uploadBackgroundImage(e){
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                    this.previewBackgroundImage = e.target.result;
                    console.log('dd');
                };
            },
            getItem()
            {
                var id = this.$route.params.id;

                db.collection('companies').doc(id).get().then((doc) => {
                    console.log(doc.data());
                    this.item = doc.data();
                    this.finds = doc.data().outlets;             
                  
          this.picture = doc.data().image;
         
         
					this.picturech = doc.data().background_image;
           
                    this.categories = [];


                })
            },

            submit()
            {
               //alert(this.picture);
              
                var id = this.$route.params.id;
                var  date = new Date().toLocaleString();//.toISOString().slice(0, 10);
                if(this.center[0]){
                   //alert( this.center[1])
                  this.latmap  = this.center[0];
                  this.lanmap  = this.center[1];
                }else{
                //alert(this.item.lat)
                 this.latmap  = this.item.lat;
                  this.lanmap  = this.item.lng;

                }

						const stores = 			      {
            'type': 'Feature',
            'geometry': {
              'type': 'Point',
              'coordinates': [ this.latmap,this.lanmap ]
            },
            'properties': {
              'phone': this.item.phone_no,
              'company_name': this.item.name,
              'logo': 	this.picture,
              'email':this.item.email,
              'cid':id,
              'website':this.item.website,
             'phone_no':this.item.phone_no,
              'about': this.item.about,
              'address': this.item.location,
              'city': this.item.location,
              'country': this.asas,
              'postalCode': this.item.postcode,
            }
          }

                db.collection("companies")
                .doc(id)
                .update({
                  cid: id,
                  subscription: this.item.subscription,
                  category: this.item.category,
                   email: this.item.email,
                  name: this.item.name,
                  code: this.item.code,
                  about: this.item.about,
                  image: 	this.picture,
                  stores: stores,
                  background_image: this.picturech,
                  location: this.item.location,
                  country: this.item.country,
                  postcode: this.item.postcode,
                  phone_no: this.item.phone_no,
                  website: this.item.website,
                  outlets: this.finds,
                  meta_title: this.item.meta_title,
                  meta_description: this.item.meta_description,
                  meta_keywords: this.item.meta_keywords,
                  lat: this.latmap,
                  lng: this.lanmap,
                  modified: date,
                })
                .then(() => {
                  console.log("Document successfully updated!");
                  //this.readEmployees();
                  this.$toasted.success('Success, Updated Successfully!', {
                    icon : 'check',
                     //icon : 'error_outline'
                 })
                 this.$router.push('/companies/index');

                })
                .catch((error) => {
                  // The document probably doesn't exist.
                  console.error("Error updating document: ", error);
                });
            }
        }
    }
</script>
<style>
.dislpay-arena[data-v-b28e1624] {
  width: 30%;
}
.coordinates-header h3[data-v-b28e1624] {
  font-size: 20px;
}
</style>
